<template>
  <div class="term-acceptance-modal" role="dialog" aria-modal="true">
    <div class="term-acceptance-card">
      <h3 v-if="title" class="term-title">{{ title }}</h3>

      <!-- eslint-disable-next-line vue/no-v-html -->
      <div class="term-body" v-html="body"></div>

      <label class="term-check">
        <input type="checkbox" v-model="agreed" :disabled="submitting" />
        <span>Li e aceito os termos acima.</span>
      </label>

      <button
        class="btn btn-primary btn-block btn-lg mt-3"
        :disabled="!agreed || submitting"
        @click="accept"
      >
        <b-spinner v-if="submitting" small />
        <span v-else>Aceito</span>
      </button>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      agreed: false,
      submitting: false
    };
  },
  computed: {
    ...mapState("term", ["status"]),
    title() {
      return (this.status && this.status.title) || "";
    },
    body() {
      return (this.status && this.status.body) || "";
    }
  },
  methods: {
    blockEscape(event) {
      if (event.key === "Escape" || event.keyCode === 27) {
        event.stopPropagation();
        event.preventDefault();
      }
    },
    accept() {
      if (!this.agreed || this.submitting) return;
      this.submitting = true;
      this.$store
        .dispatch("term/accept")
        .catch(() => {
          this.$message.error(
            "Não foi possível registrar o aceite. Tente novamente."
          );
        })
        .finally(() => {
          this.submitting = false;
        });
    }
  },
  mounted() {
    document.addEventListener("keydown", this.blockEscape, true);
    document.body.style.overflow = "hidden";
  },
  beforeDestroy() {
    document.removeEventListener("keydown", this.blockEscape, true);
    document.body.style.overflow = "";
  }
};
</script>

<style lang="scss" scoped>
.term-acceptance-modal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 100000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  background: rgba(0, 10, 20, 0.75);
  backdrop-filter: blur(4px);

  .term-acceptance-card {
    width: 100%;
    max-width: 640px;
    max-height: 90vh;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    padding: 24px;
    border-radius: 12px;
    background: #fff;
    color: #1a1a1a;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4);

    .term-title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 16px;
    }

    .term-body {
      flex: 1 1 auto;
      overflow-y: auto;
      font-size: 14px;
      line-height: 1.6;
      margin-bottom: 16px;

      ::v-deep img {
        max-width: 100%;
      }

      ::v-deep a {
        color: var(--primary, #007bff);
        text-decoration: underline;
      }
    }

    .term-check {
      display: flex;
      align-items: center;
      font-size: 14px;
      cursor: pointer;
      margin: 0;

      input {
        margin-right: 8px;
        cursor: pointer;
      }
    }
  }
}
</style>
